<template>
  <v-container fluid>
    <v-row v-if="loadingPersonalData" align="center" justify="center" style="min-height: 60vh;">
      <v-col cols="12" align="center">
        <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
        <div class="text-h5 mt-4">Cargando información del personal...</div>
      </v-col>
    </v-row>

    <v-row v-else-if="!personal" align="center" justify="center" style="min-height: 60vh;">
      <v-col cols="12" class="text-center">
        <v-icon color="error" size="80">mdi-account-alert</v-icon>
        <h2 class="mt-2">No se encontró información de personal</h2>
        <TextButton color="secondary" class="mt-4" @click="reloadPersonal">
          <v-icon left>mdi-refresh</v-icon>
          Reintentar
        </TextButton>
      </v-col>
    </v-row>

    <v-row v-else>
      <v-col cols="4">
        <TextButton text class="mx-2" @click="$router.go(-1)">
          <v-icon>mdi-arrow-left</v-icon> Volver a catálogo de personal
        </TextButton>
      </v-col>
      <v-col cols="8" align="right">
        <v-spacer></v-spacer>
        <TextButton
          rounded
          color="secondary"
          class="mx-2"
          v-if="personal.foto && personal.foto.length > 0"
          @click="download(personal.foto)"
        >
          Descargar fotografía
        </TextButton>
      </v-col>
      <v-col cols="3">
        <v-row>
          <v-col cols="12">
            <personal-card-component />
          </v-col>
          <v-col cols="12">
            <menu-list-component :estatus="personal.fk_idEstatus" />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="9">
        <datos-generales-component v-if="selectedMenu == 1" />
        <referencias-tab-content v-if="selectedMenu == 2" />
        <documentos-tab-content v-if="selectedMenu == 3" />
        <tramites-administrativos-tab-content v-if="selectedMenu == 8" />
        <puesto-dependencia-tab-content v-if="selectedMenu == 5" />
        <campos-registro-personal-tab-content v-if="selectedMenu == 6" />
        <linea-tiempo-tab-content v-if="selectedMenu == 7" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import PersonalCardComponent from '../../components/expediente/PersonalCardComponent.vue'
import MenuListComponent from '../../components/expediente/MenuListComponent.vue'
import DatosGeneralesComponent from '../../components/expediente/DatosGeneralesComponent.vue'
import DocumentosTabContent from '../../components/expediente/datos-generales/tab-content/DocumentosTabContent.vue'
import ReferenciasTabContent from '../../components/expediente/datos-generales/tab-content/ReferenciasTabContent.vue'
import TramitesAdministrativosTabContent from '../../components/expediente/datos-generales/tab-content/TramitesAdministrativosTabContent.vue'
import PuestoDependenciaTabContent from '../../components/expediente/datos-generales/tab-content/PuestoDependenciaTabContent.vue'
import LineaTiempoTabContent from '../../components/expediente/datos-generales/tab-content/LineaTiempoTabContent.vue'
import CamposRegistroPersonalTabContent from '../../components/expediente/datos-generales/tab-content/CamposRegistroPersonalTabContent.vue'
import TextButton from '../../components/base/TextButton.vue'

export default {
  components: {
    PersonalCardComponent,
    MenuListComponent,
    DatosGeneralesComponent,
    ReferenciasTabContent,
    DocumentosTabContent,
    TramitesAdministrativosTabContent,
    PuestoDependenciaTabContent,
    LineaTiempoTabContent,
    CamposRegistroPersonalTabContent,
    TextButton,
  },

  data() {
    return {
      loadingPersonalData: false,
    }
  },
  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonalSingle',
    }),
    ...mapGetters('expediente', {
      selectedMenu: 'getSelectedMenu',
    }),
  },
  async mounted() {
    this.SET_SELECTED_MENU(1)
    await this.loadPersonal()
  },
  methods: {
    ...mapActions('personal', ['fetchPersonalById']),
    ...mapMutations('expediente', ['SET_SELECTED_MENU']),
    download(url) {
      window.open(url, '_blank')
    },
    async loadPersonal() {
      this.loadingPersonalData = true
      const id = Number(this.$route.params.id)
      if (id) {
        await this.fetchPersonalById(id)
      }
      this.loadingPersonalData = false
    },
    reloadPersonal() {
      this.loadPersonal()
    },
  },
}
</script>
